import menuData from '../components/Sidebar/menuData.js';
import clipperCtasCtes from './clipperMenus.ctasctes.js';
import jetBaselineMenus from './jetMenus.baseline.js';
import { mergeMenus } from './mergeMenus.js';

const CARGAS_HIDDEN_PATHS = new Set([
  '/cargas/consulta-y-reimpresion-de-fc',
  '/cargas/ordenes-de-retiros-y-servicios',
  '/cargas/stickers-de-recepcion-de-carga',
  '/cargas/ingreso-de-remitos',
  '/cargas/control-fiscal-de-ruta-dgr',
]);

const CARGAS_HIDDEN_SECTION_LABELS = new Set([
  'novedades',
  'novedades y distribución',
]);

function normalizeMenuValue(value) {
  return String(value || '').trim().toLowerCase();
}

function sanitizeCargasMenu(menuConfig) {
  const cargasEntries = menuConfig.Cargas ?? [];

  return {
    ...menuConfig,
    Cargas: cargasEntries
      .map(entry => {
        if (entry?.type !== 'section') {
          return CARGAS_HIDDEN_PATHS.has(normalizeMenuValue(entry?.to)) ? null : entry;
        }

        if (CARGAS_HIDDEN_SECTION_LABELS.has(normalizeMenuValue(entry.label))) {
          return null;
        }

        const items = (entry.items ?? []).filter(
          item => !CARGAS_HIDDEN_PATHS.has(normalizeMenuValue(item?.to)),
        );

        if (!items.length) {
          return null;
        }

        return { ...entry, items };
      })
      .filter(Boolean),
  };
}

export const menuBaseData = menuData;
const menuWithCtasCtes = mergeMenus(menuBaseData, clipperCtasCtes);
export const mergedMenuData = sanitizeCargasMenu(
  mergeMenus(menuWithCtasCtes, jetBaselineMenus)
);

export default mergedMenuData;
